/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */

import { make } from 'vuex-pathify';

const meta = {
  namespaced: true,
  state: {
    title: process.env.VUE_APP_SITE_TITLE,
    description: process.env.VUE_APP_SITE_TITLE,
    url: process.env.VUE_APP_SITE_URL,
    canonical: process.env.VUE_APP_SITE_URL,
  },
  mutations: {},
  actions: {},
};

const mutations = {
  updateMeta: (state, payload) => {
    if (typeof payload.title !== 'undefined') {
      payload.title = `${payload.title} - mad.social`;
    } else {
      payload.title = process.env.VUE_APP_SITE_TITLE;
    }

    if (typeof payload.description === 'undefined') {
      payload.description = process.env.VUE_APP_SITE_DESCRIPTION;
    }

    // console.log('updating meta', payload);
    state.title = payload.title;
    state.description = payload.description;
    state.url = `${process.env.VUE_APP_SITE_URL}${payload.path}`;
  },
};

const actions = {
  updateMeta({ commit }, payload) {
    commit('updateMeta', payload);
  },
};

meta.mutations = Object.assign(make.mutations(meta.state), mutations);
meta.actions = Object.assign(meta.actions, actions);

export default meta;
